import { SignalingPingData, SignalingPong, SignalingSocket } from 'services/signaling';
import { RTCClient } from 'utils/webrtc';
import { REFRESH_TIMEOUT_MS } from 'utils/webrtc/refreshTimeout';
import { SubscribeTokenRefreshError } from 'utils/webrtc/subscribeGrantError';

const withTimeout = <T>(promise: Promise<T>, ms: number) =>
  new Promise<T>((resolve, reject) => {
    const timer = window.setTimeout(() => reject(new Error(`no pong within ${ms}ms`)), ms);

    promise.then(resolve, reject).finally(() => window.clearTimeout(timer));
  });

// Applied here rather than left to the pong saga: the socket resolves `sendAsync` before it
// dispatches the action that saga listens on, so awaiting the saga would race the join.
export const refreshSubscribeGrant = async (): Promise<void> => {
  const refreshPing: SignalingPingData = { refresh: true };

  try {
    const pong = await withTimeout(
      SignalingSocket.sendAsync<SignalingPong>({ event: 'ping', data: refreshPing }),
      REFRESH_TIMEOUT_MS
    );

    // Client.refreshConnectionMediaTokens no-ops on a falsy token, so a partial pong would
    // otherwise resolve as success while leaving the spent grant in place.
    if (!pong.subscribingMediaToken) {
      throw new Error('pong carried no subscribing media token');
    }

    RTCClient.refreshConnectionMediaTokens({
      publishing: pong.publishingMediaToken,
      subscription: pong.subscribingMediaToken,
    });
  } catch (error) {
    throw new SubscribeTokenRefreshError(error);
  }
};
